import { render, staticRenderFns } from "./CvView.vue?vue&type=template&id=01e48184"
import script from "./CvView.vue?vue&type=script&lang=js"
export * from "./CvView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports